import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, MessageCircle, PhoneCall } from "lucide-react";
import { EMAIL, PHONE, PHONE_TEL, WHATSAPP, leadWhatsappMessage, whatsappUrl } from "@/lib/fda";
import { LegalDisclosure } from "@/components/site/Footer";

export default function Complete() {
  const [lead, setLead] = useState(null);
  useEffect(() => {
    const raw = sessionStorage.getItem("fda_submitted_lead");
    if (raw) { try { setLead(JSON.parse(raw)); } catch { /* ignore */ } }
  }, []);

  return (
    <div data-testid="complete-page">
      <section className="px-5 py-16 lg:px-10">
        <div className="mx-auto max-w-2xl">
          <img src="/logo-on-light.png" alt="Freedom Debt Advice" data-testid="complete-logo"
            className="mb-8 h-14 w-auto max-w-full object-contain object-left" />
          <span className="grid h-14 w-14 place-items-center rounded-2xl bg-moss/20 text-moss"><CheckCircle2 className="h-7 w-7" /></span>
          <h1 className="mt-6 font-display text-3xl font-extrabold leading-tight text-forest sm:text-4xl">
            Thank you — we've received your details.
          </h1>

          {lead?.lead_reference && (
            <div className="mt-8 rounded-2xl border-2 border-forest bg-white p-6" data-testid="lead-reference-block">
              <p className="text-xs font-bold uppercase tracking-[0.18em] text-forest-soft">Your reference</p>
              <p className="mt-1 font-display text-3xl font-extrabold text-forest" data-testid="lead-reference">{lead.lead_reference}</p>
              <p className="mt-2 text-xs text-forest-soft">Please quote this reference when you speak to us.</p>
            </div>
          )}

          <ul className="mt-8 space-y-3 text-sm leading-relaxed text-forest-soft">
            <li>Your enquiry has been received and recorded by the Freedom Debt Advice team.</li>
            <li>Our team will review the information you have submitted.</li>
            <li>We may contact you at the time you told us was convenient.</li>
            <li className="font-semibold text-forest">You have not been automatically approved for any debt solution, and no
              decision about a debt solution has been made.</li>
          </ul>

          <div className="mt-10 grid gap-4 sm:grid-cols-2">
            <a href={`tel:${PHONE_TEL}`} data-testid="complete-call-button"
              className="flex flex-col rounded-2xl bg-forest p-6 text-sand transition-transform hover:-translate-y-1">
              <PhoneCall className="h-5 w-5" />
              <span className="mt-4 text-xs font-bold uppercase tracking-[0.18em] text-sand/60">Call us</span>
              <span className="mt-1 font-display text-xl font-bold">{PHONE}</span>
            </a>
            {lead ? (
              <a href={whatsappUrl(WHATSAPP, leadWhatsappMessage(lead))} target="_blank" rel="noopener noreferrer"
                data-testid="complete-whatsapp-button"
                className="flex flex-col rounded-2xl bg-moss p-6 text-white transition-transform hover:-translate-y-1">
                <MessageCircle className="h-5 w-5" />
                <span className="mt-4 text-xs font-bold uppercase tracking-[0.18em] text-white/70">Chat with us on WhatsApp</span>
                <span className="mt-1 font-display text-xl font-bold">+44 7565 207482</span>
              </a>
            ) : (
              <div className="flex flex-col justify-center rounded-2xl border-2 border-dashed border-border p-6 text-sm text-forest-soft">
                Your submission details are no longer in this browser session. Please call us on {PHONE}.
              </div>
            )}
          </div>

          <p className="mt-8 text-sm text-forest-soft">
            Prefer email? <a className="font-semibold underline" href={`mailto:${EMAIL}`}>{EMAIL}</a>
          </p>
          <Link to="/" className="mt-10 inline-block text-sm font-bold text-terracotta underline">Back to homepage</Link>
        </div>
      </section>
      <LegalDisclosure />
    </div>
  );
}
